export const SIDES_NAME = {
  Top: "H",
  Right: "D",
  Bottom: "B",
  Left: "G",
  TopLeft: "HG",
  TopRight: "HD",
  BottomRight: "BD",
  BottomLeft: "BG",
};
